<template>
	<div class="page">
		<Tip :title="title" />
		
        <div style="padding: 0 50px;">
            <div style="display: flex;justify-content: space-between;">
                <div> <span class="label-color">订单编号：</span> <span>{{detail.order_no}}</span> </div>
                <div> <span class="label-color">订单状态：</span> <span>{{detail.state_text}}</span> </div>
            </div>
            <el-divider></el-divider>

            <div style="display: flex;justify-content: space-between;">
                <div style="display: flex;width: 100%;">
                    <span class="label-color">商品信息：</span>
                    <div style="flex: 1;display: flex;flex-direction: column;">
                        <div v-for="(orderGood, cindex) in detail.order_good_arr" :key="cindex">
                            <div style="display: flex;justify-content: space-between;">
                                <div style="display: flex;">
                                    <img class="goodimg" :src="orderGood.cover_img" onerror="javascript:this.src='https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png';">
                                    <div style="text-align: left;">
                                        <div style="line-height: 16px;padding: 5px 0;"><span>名称：</span><span>{{orderGood.good_name}}</span></div>
                                        <div style="line-height: 16px;padding: 5px 0;"><span>规格：</span><span>{{orderGood.spec_data_str}}</span></div>
                                        <div style="line-height: 16px;padding: 5px 0;"><span>类型：</span><span>{{orderGood.good_type_text}}</span></div>
                                    </div>
                                </div>
                                <div style="text-align: right;">
                                    <div style="line-height: 16px;padding: 5px 0;"><span>￥</span><span>{{orderGood.sale_price}}</span></div>
                                    <div style="line-height: 16px;padding: 5px 0;"><span>x</span><span>{{orderGood.quatity}}</span></div>
                                </div>
                            </div>
                            <el-divider></el-divider>
                        </div>

                        <div class="col">
                            <div class="row" style="width: 100%;justify-content: space-between;line-height: 16px;padding: 5px 0;">
                                <span>订单备注：</span><span>{{detail.remarks ? detail.remarks : '-'}}</span>
                            </div>
                            <div class="row" style="width: 100%;justify-content: space-between;line-height: 16px;padding: 5px 0;">
                                <span>商品总价：</span><span>{{detail.total_price}}</span>
                            </div>
                            <div class="row" style="width: 100%;justify-content: space-between;line-height: 16px;padding: 5px 0;">
                                <span>物流运费：</span><span>{{detail.total_express_fee}}</span>
                            </div>
                            <div class="row" style="width: 100%;justify-content: space-between;line-height: 16px;padding: 5px 0;">
                                <span>订单总额：</span><span>{{detail.total_amount}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <el-divider></el-divider>

            <div style="display: flex;justify-content: space-between;">
                <div style="display: flex;width: 100%;"> 
                    <span class="label-color">订单历程：</span> 
                    <div style="flex: 1;display: flex;flex-direction: column;">
                        <div class="row" style="width: 100%;">
                            <div>
                                <div v-for="(log, index) in detail.logs" class="col" style="align-items: flex-start;line-height: 16px;padding: 5px 0;">
                                    {{log.info}}
                                </div>
                            </div>
                            <div style="margin-left: 10px;">
                                <div v-for="(log, index) in detail.logs" class="col" style="align-items: flex-start;line-height: 16px;padding: 5px 0;">
                                    {{log.created_time}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <el-divider></el-divider>

            <div style="display: flex;justify-content: space-between;">
                <div style="display: flex;width: 100%;"> 
                    <span class="label-color">物流信息：</span> 
                    <div style="flex: 1;display: flex;flex-direction: column;">
                        <div class="col">
                            <div class="row" style="width: 100%;">
                                <span>收货：</span><span>{{detail.receive_name}} {{detail.receive_phone}}</span>
                            </div>
                            <div class="row" style="width: 100%;">
                                <span>地址：</span><span>{{detail.receive_province}} {{detail.receive_city}} {{detail.receive_area}} {{detail.receive_street}} {{detail.receive_address}}</span>
                            </div>

                            <div v-for="(orderGood, cindex) in detail.order_good_arr" class="col" style="width: 100%;align-items: flex-start;">
                                <div v-for="(express_item, eindex) in orderGood.express" style="background-color:#E6E6E6;margin-top:10px;padding: 10px;">
                                    <span>{{express_item.express_name}}：</span><span>{{express_item.express_no}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <el-divider></el-divider>

            <div style="display: none;justify-content: space-between;">
                <div style="display: flex;width: 100%;"> 
                    <span>售后信息：</span> 
                    <div style="flex: 1;display: flex;flex-direction: column;">
                        <div class="col">
                            <div class="row" style="width: 100%;">
                                <span>申请：</span><span>{{detail.receive_name}}</span>
                            </div>
                            <div class="row" style="width: 100%;">
                                <span>描述：</span><span>{{detail.receive_province}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

		<div class="foot_div">
			<el-button @click="close">返回</el-button>
			<el-button type="primary" @click="print">打印</el-button>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
    import {
		orderDetail,
	} from "../../../request/apis.js"
	export default {
		components: {
			Tip
		},
        props: {
			type: {
				type: Number
			}
		},
		data() {
			return {
				title: '订单详情',
                detail: {},
			}
		},
		mounted() {
            this.getOrderDetail(this.type);
        },
		methods: {
			getOrderDetail(order_id){
				orderDetail({order_id}).then(res=>{
					if(res.code == 0){
                        this.detail = res.data;
					}
				}).catch(err=>{})
			},

            print() {
				this.$emit('close')
			},

			close() {
				this.$emit('close')
			}
		}
	}
</script>

<style scoped>
	.page {
		width: calc(100% - 40px);
		background: #fff;
		position: relative;
	}

	.row {
		display: flex;
		flex-direction: row;
	}

	.col {
		display: flex;
		flex-direction: column;
	}

	.from_div {
		padding-top: 20px;
		width: 100%;
		overflow: scroll;
		height: 570px;
		min-height: 100%;
		padding-bottom: 66px;
	}

	.input {
		width: 200px;
		margin-right: 20px;
	}

    .long-input {
        width: 420px;
    }

	.select {
		width: 137px;
		margin-right: 20px;
	}
	
	.picker {
		width: 420px;
	}

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
	}

	.span {
		font-size: 14px;
		color: #767676;
	}

    .goodimg { 
        width: 60px; 
        height: 60px; 
        margin-right: 14px; 
        flex-shrink: 0; 
    }
</style>